import { FolderApi, DocumentApi } from '../test-api/index.ts'
import bcFolderStore from '@/frontapp/store/bcFolder'
import bcSelectedStore from '@/frontapp/store/bcSelected'
import { mapStores } from 'pinia'
import handleApiError from '../utils/handleApiError'

const folderApi = new FolderApi({}, '/api/v2')
const documentApi = new DocumentApi({}, '/api/v2')

export default {
  props: {
    disableDraggable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
   ...mapStores(bcFolderStore, bcSelectedStore)
  },
  methods: {
    // requires defined this.parentBcFolderId in component where it is used
    async dropItem({ item, index, overElement }) {
      if (item.type === 'folder') {
        // drop on placeholder or document
        // or before start of droparea or after end of droparea
        if (overElement?.AwDndDragItem?.id === item.id || overElement?.AwDndDragItem?.type === 'document' || !overElement?.AwDndDragItem) {
          const itemParentBcFolderId = item.parent__bc_folder_id ? item.parent__bc_folder_id : 0

          // in same parent folder
          if (itemParentBcFolderId === this.parentBcFolderId) {
            const rank = index > item.rank ? index - 1 : index
            this.bcFolderStore.moveItem(item, rank)
            await handleApiError(() => folderApi.folderUpdate(item.id, {
              name: item.name,
              parent__bc_folder_id: itemParentBcFolderId,
              image__file_id: item.image__file?.id || null,
              header__file_id: item.header__file?.id || null,
              link: item.link,
              icon_bg_color: item.icon_bg_color || null,
              icon_text: item.icon_text || null,
              rank,
            }))

          // in different parent folder
          } else {
            this.bcFolderStore.moveItem(item, index, this.parentBcFolderId)
            await handleApiError(() => folderApi.folderUpdate(item.id, {
              name: item.name,
              parent__bc_folder_id: this.parentBcFolderId,
              image__file_id: item.image__file?.id || null,
              header__file_id: item.header__file?.id || null,
              link: item.link,
              icon_bg_color: item.icon_bg_color || null,
              icon_text: item.icon_text || null,
              rank: index,
            }))
          }

        // drop on different folder both in same or different parent folder
        } else {
          this.bcFolderStore.moveItem(item, 0, overElement?.AwDndDragItem?.id)
          await handleApiError(() => folderApi.folderUpdate(item.id, {
            name: item.name,
            parent__bc_folder_id: overElement?.AwDndDragItem?.id,
            image__file_id: item.image__file?.id || null,
            header__file_id: item.header__file?.id || null,
            link: item.link,
            icon_bg_color: item.icon_bg_color || null,
            icon_text: item.icon_text || null,
            rank: 0,
          }))
        }
      } else if (item.type === 'document') {
        // drop on placeholder or different document 
        // or before start of droparea or after end of droparea
        if (overElement?.AwDndDragItem?.id === item.id || overElement?.AwDndDragItem?.type === 'document' || !overElement?.AwDndDragItem) {
          const itemBcFolderId = item.bc_folder_id ? item.bc_folder_id : 0

          // in same parent folder
          if (itemBcFolderId === this.parentBcFolderId) {
            const rank = index > item.rank ? index - 1 : index
            this.bcFolderStore.moveItem(item, rank)
            await handleApiError(() => documentApi.documentUpdate(item.id, {
              name: item.name,
              bc_folder_id: itemBcFolderId,
              image__file_id: item.image__file?.id || null,
              icon_bg_color: item.icon_bg_color || null,
              icon_text: item.icon_text || null,
              rank,
            }))

          // in different parent folder
          } else {
            this.bcFolderStore.moveItem(item, index, this.parentBcFolderId)
            await handleApiError(() => documentApi.documentUpdate(item.id, {
              name: item.name,
              bc_folder_id: this.parentBcFolderId,
              image__file_id: item.image__file?.id || null,
              icon_bg_color: item.icon_bg_color || null,
              icon_text: item.icon_text || null,
              rank: index,
            }))
          }

        // drop on folder both in same or different parent folder
        } else {
          this.bcFolderStore.moveItem(item, 0, overElement?.AwDndDragItem?.id)
          await handleApiError(() => documentApi.documentUpdate(item.id, {
            name: item.name,
            bc_folder_id: overElement?.AwDndDragItem?.id,
            image__file_id: item.image__file?.id || null,
            icon_bg_color: item.icon_bg_color || null,
            icon_text: item.icon_text || null,
            rank: 0,
          }))
        }
      } 
    }
  }
}
